import React from "react";
import ReactAnimatedWeather from "react-animated-weather";

export default function WeatherIcon(props) {
  // Mapping PirateWeather icons to ReactAnimatedWeather
  const codeMapping = {
    "clear-day": "CLEAR_DAY",
    "clear-night": "CLEAR_NIGHT",
    "partly-cloudy-day": "PARTLY_CLOUDY_DAY",
    "partly-cloudy-night": "PARTLY_CLOUDY_NIGHT",
    cloudy: "CLOUDY",
    rain: "RAIN",
    snow: "SNOW",
    sleet: "SLEET",
    wind: "WIND",
    fog: "FOG",
  };

  return (
    <ReactAnimatedWeather
      icon={codeMapping[props.code] || "CLOUDY"} // fallback if code not found
      color="#9DB0CE"
      size={props.size}
      animate={true}
    />
  );
}
